<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title>
        <div class="headline">Query GL Interface</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row-wrap>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{ labels.glApplnInt }}</v-subheader>
              <div class="queryValue">{{ glIntForm.glApplnInt | glapplnIntDesc }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="GLMappingKey.sepAcctBrn">
              <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.branch">
                {{ glIntForm.branch }} <template v-if="glIntForm.brnDesc">{{ ' - ' + glIntForm.brnDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctCtyRisk">
              <v-subheader class="queryLabel">{{ labels.ctyRisk }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.ctyRisk">
                {{ glIntForm.ctyRisk }} <template v-if="glIntForm.ctyRiskDesc">{{ ' - ' + glIntForm.ctyRiskDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctDri">
              <v-subheader class="queryLabel">{{ labels.dri }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.dri">{{ glIntForm.dri + ' - ' + driList[glIntForm.dri] }}</div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctPolType">
              <v-subheader class="queryLabel">{{ labels.polType }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.polType">
                {{ glIntForm.polType }} <template v-if="glIntForm.polTypeDesc">{{ ' - ' + glIntForm.polTypeDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctBusCls">
              <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.busCls">
                {{ glIntForm.busCls }} <template v-if="glIntForm.busClsDesc">{{ ' - ' + glIntForm.busClsDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctDept">
              <v-subheader class="queryLabel">{{ labels.dept }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.dept">
                {{ glIntForm.dept }} <template v-if="glIntForm.deptDesc">{{ ' - ' + glIntForm.deptDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctCtyCed">
              <v-subheader class="queryLabel">{{ labels.ctyCed }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.ctyCed">
                {{ glIntForm.ctyCed }} <template v-if="glIntForm.ctyCedDesc">{{ ' - ' + glIntForm.ctyCedDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctCtyRi">
              <v-subheader class="queryLabel">{{ labels.ctyRi }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.ctyRisk">
                {{ glIntForm.ctyRi }} <template v-if="glIntForm.ctyRiDesc">{{ ' - ' + glIntForm.ctyRiDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctStmtLvl">
              <v-subheader class="queryLabel">{{ labels.stmtLvl }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.stmtLvl">{{ glIntForm.stmtLvl + ' - ' + stmtLvlList[glIntForm.stmtLvl] }}</div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctStmtLnGL">
              <v-subheader class="queryLabel">{{ labels.stmtLnGl }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.stmtLnGl">
                {{ glIntForm.stmtLnGl }} <template v-if="glIntForm.ctyRiDesc">{{ ' - ' + glIntForm.ctyRiDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctBAGL">
              <v-subheader class="queryLabel">{{ labels.baGl }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.baGl">
                {{ glIntForm.baGl }} <template v-if="glIntForm.ctyRiDesc">{{ ' - ' + glIntForm.ctyRiDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctCedAreaGL">
              <v-subheader class="queryLabel">{{ labels.cedAreaGl }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.cedAreaGl">
                {{ glIntForm.cedAreaGl }} <template v-if="glIntForm.ctyRiDesc">{{ ' - ' + glIntForm.ctyRiDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctRIAreaGL">
              <v-subheader class="queryLabel">{{ labels.riAreaGl }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.riAreaGl">
                {{ glIntForm.riAreaGl }} <template v-if="glIntForm.ctyRiDesc">{{ ' - ' + glIntForm.ctyRiDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctRiskAreaGL">
              <v-subheader class="queryLabel">{{ labels.riskAreaGl }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.riskAreaGl">
                {{ glIntForm.riskAreaGl }} <template v-if="glIntForm.ctyRiDesc">{{ ' - ' + glIntForm.ctyRiDesc }}</template>
              </div>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctCesCat">
              <v-subheader class="queryLabel">{{ labels.cesCat }}</v-subheader>
              <div class="queryValue" v-if="glIntForm.cesCat">
                {{ glIntForm.cesCat }} <template v-if="glIntForm.ctyRiDesc">{{ ' - ' + glIntForm.ctyRiDesc }}</template>
              </div>
            </v-flex>
          </v-layout>
          <v-divider class="mt-3"></v-divider>
          <v-card-title>
            <div class="body-2">To GL Account</div>
          </v-card-title>
          <v-layout row-wrap>
            <v-flex xs2>
              <v-text-field :label="labels.glAcctBrn" v-model="glIntForm.glAcctBrn" readonly></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field :label="labels.glAcctNo" v-model="glIntForm.glAcctNo" readonly></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field :label="labels.glAcctFund" v-model="glIntForm.glAcctFund" readonly></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field :label="labels.glAcctSfx" v-model="glIntForm.glAcctSfx" readonly></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row-wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ glIntForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ glIntForm.createdDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout row-wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ glIntForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ glIntForm.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-btn color="primary" dark class=" mr-2" @click="doBack">
            Back
            <v-icon right>mdi-view-list</v-icon>
          </v-btn>
        </v-container>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { glAppInterface } from '@/const/acct/glAcct'
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
// import GlAcctNoHelplist from './helplist/GLAcctNoHelplist'
// import Helplist from '@/components/parameters/helplist/helplist'
export default {
  data() {
    return {
      labels: {
        glApplnInt: 'GL Application Interface',
        branch: 'Branch',
        ctyRisk: 'Country Risk',
        dri: 'Direct / RI Inwards',
        polType: 'Policy Type',
        busCls: 'Business Class',
        dept: 'Department',
        ctyCed: 'Country Cedant',
        ctyRi: 'Country RI',
        clmResCat: 'Claim Reserve Category',
        glAcctBrn: 'Branch',
        glAcctNo: 'Account No.',
        glAcctFund: 'Fund',
        glAcctSfx: 'Suffix',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        stmtLvl: 'Statement Level',
        stmtLnGl: 'Statement Line GL',
        baGl: 'Business Analysis GL',
        cedAreaGl: 'Cedant Area GL',
        riAreaGl: 'RI Area GL',
        cesCat: 'Cession Category',
        riskAreaGl: 'Risk Area GL'
      },
      glIntForm: {
        glApplnInt: this.$route.params.glApplnInt,
        branch: null,
        brnDesc: null,
        ctyRisk: null,
        ctyRiskDesc: null,
        dri: null,
        polType: null,
        polTypeDesc: null,
        busCls: null,
        busClsDesc: null,
        dept: null,
        deptDesc: null,
        ctyCed: null,
        ctyCedDesc: null,
        ctyRi: null,
        ctyRiDesc: null,
        clmResCat: '',
        glAcctBrn: null,
        glAcctNo: null,
        glAcctFund: null,
        glacctSfx: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null,
        stmtLvl: null,
        stmtLnGl: null,
        stmtLnGLDesc: null,
        baGl: null,
        busAnGLDesc: null,
        cedAreaGl: null,
        cedAreaGLDesc: null,
        riAreaGl: null,
        riAreaGLDesc: null,
        riskAreaGl: null,
        riskAreaGLDesc: null,
        cesCat: null,
        cesCatDesc: null
      }
    }
  },
  methods: {
    async loadHelplist() {
      const apiURI = this.menu.glIntHelplist
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.helplistMenu = extractMenu(result.data._links)
          this.glSys = data.MiscAcctParam.glSys
        }
      }
    },
    async doInit() {
      this.loadHelplist()
      const apiURI = this.menu.glInterface2
      if (apiURI) {
        try {
          const expand = {
            glApplnInt: this.id.glApplnInt,
            branch: this.id.branch,
            ctyRisk: this.id.ctyRisk,
            dri: this.id.dri,
            polType: this.id.polType,
            busCls: this.id.busCls,
            dept: this.id.dept,
            ctyCed: this.id.ctyCed,
            ctyRi: this.id.ctyRi,
            clmResCat: this.id.clmResCat,
            stmtLvl: this.id.stmtLvl,
            stmtLnGl: this.id.stmtLnGl,
            baGl: this.id.baGl,
            cedAreaGl: this.id.cedAreaGl,
            riAreaGl: this.id.riAreaGl,
            riskAreaGl: this.id.riskAreaGl,
            cesCat: this.id.cesCat
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.glIntForm.glApplnInt = data.GLInterface.glApplnInt
            this.glIntForm.branch = data.GLInterface.branch
            if (data.branch) {
              if (this.glSys === 2) {
                this.glIntForm.brnDesc = data.branch.glanDesc
              } else {
                this.glIntForm.brnDesc = data.branch.brnDesc
              }
            }
            this.glIntForm.ctyRisk = data.GLInterface.ctyRisk
            if (data.ctyRisk) {
              if (this.glSys === 2) {
                this.glIntForm.ctyRiskDesc = data.ctyRisk.glanDesc
              } else {
                this.glIntForm.ctyRiskDesc = data.ctyRisk.regn1Desc
              }
            }
            this.glIntForm.dri = data.GLInterface.dri
            this.glIntForm.polType = data.GLInterface.polType
            if (data.polType) {
              if (this.glSys === 2) {
                this.glIntForm.polTypeDesc = data.polType.glanDesc
              } else {
                this.glIntForm.polTypeDesc = data.polType.polTypeDesc
              }
            }
            this.glIntForm.busCls = data.GLInterface.busCls
            if (data.busCls) {
              if (this.glSys === 2) {
                this.glIntForm.busClsDesc = data.busCls.glanDesc
              } else {
                this.glIntForm.busClsDesc = data.busCls.busClsDesc
              }
            } else if (data.polTypeCls) {
              this.glIntForm.busClsDesc = data.polTypeCls.busClsDesc
            }
            this.glIntForm.dept = data.GLInterface.dept
            if (data.dept) {
              if (this.glSys === 2) {
                this.glIntForm.deptDesc = data.dept.glanDesc
              } else {
                this.glIntForm.deptDesc = data.dept.deptDesc
              }
            }
            this.glIntForm.ctyCed = data.GLInterface.ctyCed
            if (data.ctyCed) {
              if (this.glSys === 2) {
                this.glIntForm.ctyCedDesc = data.ctyCed.glanDesc
              } else {
                this.glIntForm.ctyCedDesc = data.ctyCed.regn1Desc
              }
            }
            this.glIntForm.ctyRi = data.GLInterface.ctyRi
            if (data.ctyRi) {
              if (this.glSys === 2) {
                this.glIntForm.ctyRiDesc = data.ctyRi.glanDesc
              } else {
                this.glIntForm.ctyRiDesc = data.ctyRi.regn1Desc
              }
            }
            this.glIntForm.clmResCat = data.GLInterface.clmResCat
            this.glIntForm.glAcctBrn = data.GLInterface.glAcctBrn
            this.glIntForm.glAcctNo = data.GLInterface.glAcctNo
            this.glIntForm.glAcctFund = data.GLInterface.glAcctFund
            this.glIntForm.glAcctSfx = data.GLInterface.glAcctSfx
            this.glIntForm.createdBy = data.createdBy
            this.glIntForm.createdDate = data.createdDate
            this.glIntForm.modifiedBy = data.modifiedBy
            this.glIntForm.modifiedDate = data.modifiedDate

            this.glIntForm.stmtLvl = data.GLInterface.stmtLvl
            this.glIntForm.stmtLnGl = data.GLInterface.stmtLnGl
            if (data.stmtLnGL) {
              this.glIntForm.stmtLnGLDesc = data.stmtLnGL.stmtLnGLDesc
            }
            this.glIntForm.baGl = data.GLInterface.baGl
            if (data.baGl) {
              this.glIntForm.busAnGLDesc = data.busAnGL.busAnGLDesc
            }
            this.glIntForm.cedAreaGl = data.GLInterface.cedAreaGl
            if (data.cedAreaGl) {
              this.glIntForm.cedAreaGLDesc = data.cedAreaGL.riskAreaGLDesc
            }
            this.glIntForm.riAreaGl = data.GLInterface.riAreaGl
            if (data.riAreaGl) {
              this.glIntForm.riAreaGLDesc = data.riAreaGL.riskAreaGLDesc
            }
            this.glIntForm.riskAreaGl = data.GLInterface.riskAreaGl
            if (data.riskAreaGl) {
              this.glIntForm.riskAreaGLDesc = data.riskAreaGL.riskAreaGLDesc
            }
            this.glIntForm.cesCat = data.GLInterface.cesCat
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doClose() {
      this.helplist = false
      this.helplistFieldKey2 = null
      setTimeout(() => {
        this.glacctNoHelplist = false
        this.generalHelplist = false
      }, 200)
    },
    doBack() {
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    GLMappingKey() {
      return this.$store.state.glAcctParam.glMapping.glMappingKey
    },
    driList() {
      return {
        D: 'Direct',
        R: 'RI Inwards'
      }
    },
    stmtLvlList() {
      return {
        2: '2'
      }
    }
  },
  filters: {
    glapplnIntDesc(value) {
      return value + ' - ' + glAppInterface[value]
    },
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  mixins: [MessageMixin],
  props: {
    id: Object
  }
}
</script>

<style>
</style>
